import { gql } from '@apollo/client';

export const UPDATE_MUSCLE_GROUP = gql`
    mutation updateMuscleGroup($id: ID!, $muscleGroupInput: MuscleGroupInput!){
        updateMuscleGroup(id: $id, muscleGroupInput: $muscleGroupInput) {
            _id
        }
    }
`;
